<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <div>
        <CardsView
          class="mt-5"
          :items="items"
          :openDialog="openDialog"
          :title="title"
          @goToItem="goToItem"
          :showAdd="false"
          :showDelete="false"
          :showEdit="false"
        />
      </div>
    </v-col>
  </v-row>
</template>
<script>
import groups from "@/store/horarios/groups";
import holidays from "@/store/horarios/holidays";
import schedules from "@/store/horarios/schedules";
import CardsView from "@/components/Complement/CardsView.vue";
import employeesSchedules from "@/store/horarios/employees";
export default {
  components: { CardsView },
  data: () => ({
    showCard: true,
  }),
  props: {
    itemId: Number,
  },

  mounted() {},
  computed: {
    schedules() {
      return schedules.state.schedules;
    },
    segment() {
      return schedules.state.segments;
    },
    padding() {
      return schedules.state.paddingNav;
    },
    title() {
      const parsedId = parseInt(this.itemId);
      const schedule = this.schedules.find(
        (schedule) => schedule.id === parsedId
      );
      return schedule ? schedule.name : "";
    },

    items() {
      return [
        { name: "Segmentos" },
        { name: "Empleados" },
        { name: "Grupos" },
        { name: "Grupos de feriados" },
      ];
    },
  },

  methods: {
    cardView(value) {
      this.showCard = value;
    },

    goToItem(item) {
      switch (item.name) {
        case "Segmentos":
          schedules.commit("setScheduleId", this.itemId);
          schedules.dispatch("getSegments").then(() => {
            schedules.dispatch("handleShowWindow", "segment");
          });
          break;
        case "Empleados":
          employeesSchedules.commit("setScheduleId", this.itemId);
          employeesSchedules.dispatch("getEmployees").then(() => {
            schedules.dispatch("handleShowWindow", "employees");
          });
          break;
        case "Grupos":
          groups.commit("setScheduleId", this.itemId);
          groups.dispatch("getGroups").then(() => {
            schedules.dispatch("handleShowWindow", "groups");
          });
          break;
        case "Grupos de feriados":
          holidays.commit("setScheduleId", this.itemId);
          holidays.dispatch("getHolidaysId").then(() => {
            schedules.dispatch("handleShowWindow", "holiday");
          });
          break;

        default:
          break;
      }
    },
    openDialog() {},
  },
};
</script>
<style scoped></style>
